import validate from "/opt/render/project/src/apps/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/render/project/src/apps/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-guard": () => import("/opt/render/project/src/apps/frontend/middleware/authGuard.ts"),
  slp: () => import("/opt/render/project/src/apps/frontend/middleware/slp.ts"),
  "smart-link-vehicle-resolver": () => import("/opt/render/project/src/apps/frontend/middleware/smartLinkVehicleResolver.ts"),
  "sidebase-auth": () => import("/opt/render/project/src/apps/frontend/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}